module.exports = __webpack_public_path__ + "img/worksbot_img19122406.fb8eb2a9.jpg";